module.exports = "mutation UpdateHotlineQuestion($data:HotlineQuestionInput!){updateHotlineQuestion(data:$data){success}}"